<template>
<div>

    <v-card>
        <v-card-text>
            <p class="title">Are you sure you want to increment all grade levels?</p>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="$emit('close')">No</v-btn>
            <v-btn @click="increment" color="primary">Yes</v-btn>
        </v-card-actions>
    </v-card>

    <v-dialog v-model="alertStatus" max-width="500px">
        <v-card>
            <v-card-text>
                <v-alert class="title" :value="true" :type="alertType">{{ alertMessage }}</v-alert>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="alertStatus = false">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</div>
</template>

<script>
export default {
    data() {
        return {
            alertStatus: false,
            alertType: 'success',
            alertMessage: ''
        }
    },
    methods: {
        increment() {
            this.$emit('close')
            this.$store.dispatch('incrementStudentGradeLevels')
                .then(() => {
                    this.alertStatus = true
                    this.alertType = 'success'
                    this.alertMessage = 'Grade levels successfully updated!'
                })
                .catch((error) => {
                    this.alertStatus = true
                    this.alertType = 'error'
                    this.alertMessage = error.response.data.message
                })
        }
    }
}
</script>
